import { tableColumns } from './columns/tableColumns';

export default {
  data() {
    return {
      baseColumns: [],
      productServiceDisabled: false,
      uploadDisabled: false,
      deleteFileDisabled: false,
      disablePartners: false,
      // 审批中及已生效状态下仅可上传附件不可删除附件；
    };
  },
  methods: {
    disableAll() {
      let tl = tableColumns(this);
      this.baseColumns = tl.map((item) => {
        return { ...item, disabled: true };
      });
      this.uploadDisabled = true;
      this.productServiceDisabled = true;
      this.disablePartners = true;
    },
    normalEnable() {
      let tl = tableColumns(this);
      this.baseColumns = tl.map((item) => {
        if (['projectName', 'projectCode'].includes(item.prop)) {
          return { ...item, disabled: true };
        } else {
          return item;
        }
      });
      this.uploadDisabled = false;
      this.productServiceDisabled = false;
    },
    getProcessedBaseColumns(status = '', origin) {
      let tl = tableColumns(this);

      if (this.baseInfoData.projectSourceType == 'SWQT') {
        //特殊过滤
        tl = tl.filter(
          (item) =>
            ![
              'bidTitle',
              'bidderId',
              'bidTotalAmount',
              'bidOpeningDate',
              'bidClosingDate',
            ].includes(item.prop)
        );
      }

      console.log('formStatus', status, origin);

      if (origin == 'create') {
        this.baseColumns = tl;
        return;
      }
      if (origin == 'copy') {
        this.baseColumns = tl;
        return;
      }
      if (origin == 'detail') {
        if (this.pageMode == 1) {
          this.disableAll();
        } else {
          if (status == '审批中' || status == '执行中') {
            this.deleteFileDisabled = true;
          }
          if (status == '审批中' || status == '已作废') {
            this.disablePartners = true;
          } else {
            this.disablePartners = false;
          }

          if (status == '审批通过' || status == '执行中') {
            // 此状态下页面变为可编辑状态时，
            // 部分字段限制不允许修改，
            // 包括创建组织、销售组织、投标抬头、投标人员、项目名称、项目编号、立项申请日期、开标日期、截标日期、项目来源；

            // 若状态为“审批通过”，页面上将存在编辑按钮，
            // 点击编辑按钮，则进入到项目编辑页面（类似项目新增页面，部分字段控制无法编辑），
            this.uploadDisabled = false;
            this.productServiceDisabled = false;
            this.baseColumns = tl.map((item) => {
              let list = [
                'createDepartmentName',
                // 'saleDepartmentName',
                'bidTitle',
                'bidderId',
                'projectName',
                'projectCode',
                'applyDate',
                'bidOpeningDate',
                'bidClosingDate',
                'projectSourceType',
              ];
              if (list.includes(item.prop)) {
                return { ...item, disabled: true };
              } else {
                return item;
              }
            });
            return;
          } else if (status == '审批中') {
            this.disableAll();
            return;
          } else {
            this.normalEnable();
          }
        }
      }

      if (origin == 'record') {
        this.disableAll();
      }
    },
  },
  computed: {},
  mounted() {
    this.baseColumns = tableColumns(this);
  },
};
